// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import { productCarouselProductStyles } from "@cahaba/Overrides/Components/ProductCarouselProduct";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        css: css`
            margin-bottom: 6px;
        `,
        typographyProps: {
            size: 18,
            weight: 600,
            color: "secondary.main",
            css: css`
                color: ${getColor("secondary.main")} !important;
            `,
        },
    },
};

productCarouselProductStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 1;
            margin-bottom: 6px;
            display: flex;
            align-items: flex-end;
        `,
    },
    erpNumberLabelText: { size: 13 },
    erpNumberValueText: { size: 13 },
};

productCarouselProductStyles.productPriceWrapper = {
    css: css`
        flex-grow: 0;
        margin-bottom: 6px;
        display: flex;
        align-items: flex-end;
    `,
};

productCarouselProductStyles.addToCartContainer = {
    gap: 0,
    css: css`
        flex-grow: 0;
        width: calc(100% + 20px);
        margin-left: -10px;
    }
    `,
};

productCarouselProductStyles.productQuantityOrderedStyles = {
    cssOverrides: {
        formField: css`
            margin-top: 0;
            margin-right: 0;
        `,
        inputSelect: css`
            border-top: 1px solid ${getColor("common.border")};
            border-right: 1px solid ${getColor("common.border")};
            border-bottom: none;
            border-left: none;
            text-align: center;
            font-weight: 700;
        `,
    },
};

productCarouselProductStyles.productAddToListLinkStyles = {
    link: {
        typographyProps: { size: 14, weight: 600 },
        css: css`
            text-align: center;
            justify-content: center;
            margin-top: 10px;
        `,
    },
};

productCarouselProductStyles.wrapper = {
    css: css`
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 10px 10px 0px 10px;
        border: 1px solid ${getColor("common.border")};
    `,
};

productCarouselProductStyles.addToCartButtonIcon = {
    color: "white",
    size: 10,
    css: css`
        margin-left: 7px;
        svg {
            fill: #ffffff;
        }
    `,
};
